export default "__VITE_ASSET__CjH2AjXg__"